<template>
  <div class="report-button" @click.stop="showPresentationReportAction({presentation,trigger: 'report-button'})">
    <aha-icon
      name="multiple-choice-w"
      width="18"
      height="18"
      viewBox="0 0 30 30"
      class="mr-0.5"
    />
    <strong>{{ $i18nPresenter.t('Report') }}</strong>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  props: {
    presentation: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    ...mapActions('presentationReport', ['showPresentationReportAction']),
  },
}
</script>

<style lang="scss" scoped>
  .report-button {
    @apply flex items-center px-1.5 py-0.5 rounded-md text-xs opacity-0;
    @apply bg-purple-10 text-purple-50 hover:bg-purple-50 hover:text-base-0 transition-colors;
  }
</style>
